import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=c098f234&scoped=true"
import script from "./edit-user.vue?vue&type=script&lang=ts"
export * from "./edit-user.vue?vue&type=script&lang=ts"
import style0 from "./edit-user.vue?vue&type=style&index=0&id=c098f234&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098f234",
  null
  
)

export default component.exports